$(function () {
  var currentAjaxRequest = null;
  $('form[action="/search"]').each(function () {
    var typingTimer; // used for debounce
    var thisForm = $(this);
    var blockSearch = thisForm.closest('.block-search');
    var currentFocusIndex = 0;
    thisForm.find('input[name="q"]').on('keyup', function (event) {
      var thisInput = $(this);
      if (
        (event.keyCode === 8) // backspace
        ||
        (event.keyCode === 46) // delete
        ||
        (event.keyCode >= 48 && event.keyCode <= 57) // numbers
        ||
        (event.keyCode >= 65 && event.keyCode <= 90) // letters
        ||
        (event.keyCode === 224) // cmd left
        ||
        (event.keyCode === 17) // ctrl left
        ||
        (event.keyCode === 32) // space bar
      ) {
        var searchTerm = thisInput.val().trim();
        var previousSearchTerm = thisInput.attr('data-search-term');
        var resultsList = blockSearch.find('.search-suggestion_list');
        // debounce 200ms
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
          // empty search
          if (!searchTerm) {
            // clear the search suggestion
            resetSearchSuggestion(blockSearch, true);
          } else {
            // if it's different for the previous one
            if (searchTerm != previousSearchTerm) {
              blockSearch.find('[data-close-suggestions]').hide();
              // enable loader
              blockSearch.find('.searching-suggestions-loader').show();
              // aborting any Ajax request that's currently being processed
              if (currentAjaxRequest != null) currentAjaxRequest.abort();
              // pulling results
              $.getJSON('/search/suggest.json', {
                'q': searchTerm,
                'resources': {
                  'type': 'product',
                  'limit': 6,
                  'options': {
                    'unavailable_products': 'hide',
                    "fields": "title,variants.title,body"
                  }
                }
              }).done(function (response) {
                // clear the search suggestion
                resetSearchSuggestion(blockSearch, false);
                // saving search term (to avoid search for same one)
                thisInput.attr('data-search-term', searchTerm);
                var productSuggestions = response.resources.results.products;
                blockSearch.find('[data-close-suggestions]').show();
                blockSearch.find('.search-suggestion').show();
                if (productSuggestions.length > 0) {
                  resultsList.empty();
                  $.each(productSuggestions, function (index, item) {
                    if (index > 4) {
                      return false; // breaks
                    }
                    var listItem = [
                      '<li data-index="' + (index + 1) + '">',
                      '<a href="' + item.url + '" title="' + item.title + '" class="search-suggestion_item flex transition">',
                      '<div class="search-suggestion_image transition">',
                      '<div class="embed-responsive embed-responsive-1by1">',
                      '<img class="embed-responsive-item transition" src="' + item.image + '" alt="' + item.title + '">',
                      '</div>',
                      '</div>',
                      '<div class="search-suggestion_content flex flex-grow-1">',
                      '<div class="flex-grow-1 search-suggestion_name transition">' + item.title + '</div>',
                      '<div class="flex items-end">',
                      '<div class="flex-grow-1 variant_price">' + $('#currency_selected_symbol').attr('data-value') + item.price_min + '</div>',
                      '<div class="percentage_value">SAVE ' + Math.round((item.compare_at_price_min - item.price_min) * 100 / item.compare_at_price_min) + '%</div>',
                      '</div>',
                      '</div>',
                      '</a>',
                      '</li>',
                    ].join('');
                    resultsList.append(listItem);
                  });
                  if (productSuggestions.length > 5) {
                    blockSearch.find('.search-suggestion_footer').show();
                  } else {
                    blockSearch.find('.search-suggestion_footer').hide();
                  }
                } else {
                  // clear the search suggestion
                  resetSearchSuggestion(blockSearch, false);
                }
              });
            } else { // if it's same as previous search
              blockSearch.find('[data-close-suggestions]').show();
              blockSearch.find('.search-suggestion').show();
            }
          } // if it's not empty search
        }, 200); // delay
      } else if (event.keyCode === 40) { // arrow down
        if (blockSearch.find('.search-suggestion').is(':visible')) {
          blockSearch.find('.search-suggestion li').removeClass('active');
          var viewAllvisibility = 1;
          if (blockSearch.find('.search-suggestion_footer').is(':hidden')) {
            viewAllvisibility = 0;
          }
          // if the next index is greater then the lenght of the result then start from the beginning
          if ((currentFocusIndex + 1) > (blockSearch.find('.search-suggestion_list li').length + viewAllvisibility)) {
            currentFocusIndex = 1;
          } else {
            currentFocusIndex = currentFocusIndex + 1;
          }
          blockSearch.find('.search-suggestion [data-index=' + currentFocusIndex + ']').addClass('active');
        }
      } else if (event.keyCode === 38) { // arrow up
        if (blockSearch.find('.search-suggestion').is(':visible')) {
          blockSearch.find('.search-suggestion li').removeClass('active');
          var viewAllvisibility = 1;
          if (blockSearch.find('.search-suggestion_footer').is(':hidden')) {
            viewAllvisibility = 0;
          }
          if ((currentFocusIndex - 1) <= 0) {
            currentFocusIndex = blockSearch.find('.search-suggestion_list li').length + viewAllvisibility;
          } else {
            currentFocusIndex = currentFocusIndex - 1;
          }
          blockSearch.find('.search-suggestion [data-index=' + currentFocusIndex + ']').addClass('active');
        }
      } else if (event.keyCode === 27) { // escape
        if (blockSearch.find('.search-suggestion').is(':visible')) {
          currentFocusIndex = 0;
          $('.search-suggestion').hide();
        }
      } else if (event.keyCode === 13) { // enter
        if (blockSearch.find('.search-suggestion').is(':visible') &&
          blockSearch.find('.search-suggestion [data-index]').hasClass('active') &&
          blockSearch.find('.search-suggestion [data-index].active').attr('data-index') != 6) {
          blockSearch.find('.search-suggestion [data-index].active a').get(0).click();
        } else {
          thisForm.submit();
        }
      } // if char keyCode
    }); // input event listener
    $('[data-close-suggestions]').on('click', function () {
      var blockSearch = $(this).closest('.block-search');
      // clear the search suggestion
      resetSearchSuggestion(blockSearch, true);
      // reset input
      blockSearch.find('input[name="q"]').val('');
    });
    function resetSearchSuggestion(blockSearch, hideCloseButton) {
      if (hideCloseButton) {
        blockSearch.find('[data-close-suggestions]').hide();
      }
      blockSearch.find('.search-suggestion').hide();
      blockSearch.find('.search-suggestion_footer').hide();
      blockSearch.find('.searching-suggestions-loader').hide();
      blockSearch.find('.search-suggestion li').removeClass('active');
      currentFocusIndex = 0;
    }
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.block-search').length) {
        $('.search-suggestion').hide();
      }
    });
    thisForm.on('hover mouseenter', '.search-suggestion li', function () {
      currentFocusIndex = 0;
      $('.block-search .search-suggestion li').removeClass('active');
    });
    thisForm.find('input[name="q"]').keydown(function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  });
  removeExtraUtmOnSearchResultItems();
});
function removeExtraUtmOnSearchResultItems() { // because that code is shared with collections
  $('.template-search .floating_carousel_slide:not(.floating_carousel_slide_placeholder)').each(function () {
    var newNameUrl = $(this).find('.embed-responsive-item').attr('href').replace(/\?utm_source=.+$/, '');
    $(this).find('.embed-responsive-item').attr('href', newNameUrl);
    var newImageUrl = $(this).find('.floating_carousel_product_name').attr('href').replace(/\?utm_source=.+$/, '');
    $(this).find('.floating_carousel_product_name').attr('href', newImageUrl);
  });
}